import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Box, Typography } from "@mui/material";
import UserProfile from "../../../../user_contract_request/parts/UserProfile";
import ProjectRequestDetail from "../../../../user_contract_request/parts/ProjectRequestDetail";

const UserContractRequestPage = ({}) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [userContractRequestInfo, setUserContractRequestInfo] = useState(null);
  const [userContractRequest, setUserContractRequest] = useState(null);

  useEffect(() => {
    fetch(`/company/candidates/${id}/contract_request.json`)
      .then((res) => res.json())
      .then((data) => {
        setUserContractRequestInfo(data.user_contract_request_info);
        setUserContractRequest(data.user_contract_request);
        setLoading(false);
      });
  }, [id]);

  // データ未取得時のローディング表示
  if (loading) {
    return (
      <Box p={4} ml={4}>
        <Typography>読み込み中...</Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ bgcolor: "white" }}>
        {/* プロフィール */}
        <UserProfile
          userContractRequestInfo={userContractRequestInfo}
          viewerType="company"
        />
      </Box>

      <Container maxWidth="md" sx={{ my: 5 }}>
        {/* 募集要項 */}
        <ProjectRequestDetail
          userContractRequestInfo={userContractRequestInfo}
          userContractRequest={userContractRequest}
          viewerType="company"
        />
      </Container>
    </>
  );
};

export default UserContractRequestPage;
